import { getAnalytics } from "@tm/insurance/analytics";
import { useBreakpointV2 } from "@tm/ui-widgets";
import { useEffect, useRef, useState } from "react";
import { ChatbotIcon, ChatbotIframe } from "./Chatbot.style";

interface ChatBotProp {
  myraUrl: string;
  pageName?: string;
}

const Chatbot = ({ myraUrl, pageName }: ChatBotProp) => {
  const [showChatBot, setShowChatBot] = useState(false);
  const device = useBreakpointV2();
  const analytics = getAnalytics();
  const ref = useRef<HTMLDivElement | null>(null);

  const getMyraAppLinkOrigin = () => {
    try {
      return new URL(myraUrl).origin;
    } catch (e) {
      return "Error getting myra url origin";
    }
  };

  const handleMessage = (event: MessageEvent) => {
    // Ensure the message comes from the correct origin
    if (event.origin !== getMyraAppLinkOrigin()) {
      return;
    }

    const { type } = event.data || {};
    if (
      type === "CHAT_BOT__BRIDGE__MINIMIZE_VIEW" ||
      type === "CHAT_BOT__BRIDGE__CLOSE_VIEW"
    ) {
      setShowChatBot(false);
    }
  };

  const handleClickOutside = (event: Event) => {
    if (ref?.current && !ref?.current?.contains(event.target as Node)) {
      setShowChatBot(false);
    }
  };

  const addChatbotAnalytics = (
    eventName: "chatbot_shown" | "chatbot_clicked"
  ) => {
    if (pageName) {
      switch (pageName) {
        case "LANDING":
          analytics?.trackLandingEvents({ actionType: eventName });
          break;
        case "LISTING":
          analytics?.trackListingEvents({ actionType: eventName });
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    // Attach event listener to listen for messages from the iframe
    window.addEventListener("message", handleMessage);
    addChatbotAnalytics("chatbot_shown");
    // Cleanup on component unmount
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (device === "sm") {
      if (showChatBot) {
        document.body.style.overflow = "hidden";
      }
      if (!showChatBot) {
        document.body.style.overflow = "auto";
      }
    }

    if (showChatBot) {
      document.addEventListener("click", handleClickOutside, false);
    } else {
      document.removeEventListener("click", handleClickOutside, false);
    }
  }, [showChatBot]);

  const chatbotClickHandler = () => {
    setShowChatBot(true);
    addChatbotAnalytics("chatbot_clicked");
  };

  return (
    <div ref={ref}>
      <ChatbotIcon
        src="https://imgak.mmtcdn.com/flights/assets/media/mobile/listing/3X/myra_new_gif.webp?v=2"
        alt="Myra Animation"
        onClick={chatbotClickHandler}
      />

      {showChatBot && (
        <ChatbotIframe device={device} src={myraUrl} title="myraChatBot" />
      )}
    </div>
  );
};

export default Chatbot;
